import { jsxs, jsx } from "react/jsx-runtime";
const IconAttachmentSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M11 21.6c-1.8 0-3.7-.8-5.1-2.1-2.7-2.7-2.7-7.2 0-9.9l5.7-5.7c1.9-1.9 5.1-2 7.1 0 1.9 1.9 1.9 5.1 0 7.1L13 16.7c-1.2 1.2-3.1 1.2-4.2 0-.6-.6-.9-1.3-.9-2.1 0-1.2.3-1.6.9-2.1L12.3 9c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-3.5 3.5c-.2.2-.3.4-.3.7s.1.5.3.7c.4.4 1 .4 1.4 0l5.7-5.7c1.2-1.2 1.2-3.1 0-4.2-1.2-1.2-3.1-1.2-4.2 0l-5.7 5.7c-1.9 1.9-1.9 5.1 0 7.1 1.9 1.9 5.1 1.9 7.1 0l3.5-3.5c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-3.5 3.5c-1.4 1.4-3.2 2-4.9 2Z" })
    ]
  }
);
export {
  IconAttachmentSvg
};
